import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  // Get token and tenantId from localStorage
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('tenantId');

  return {
    ...context,
    token,
    tenantId
  };
};

export default useAuth; 